import React from "react";
import { Stack } from "@mui/material";
import PostFoundryTableHeader from "./PostFoundryTableHeader";
import PostFoundryTableBody from "./PostFoundryTableBody";

export const PostFoundryTable = ({ basePath, ...rest }) => {
  return (
    <Stack
      id="PostFoundryTable"
      border="1px solid"
      borderColor="hubColors.greyLight"
    >
      <PostFoundryTableHeader />
      <PostFoundryTableBody basePath={basePath} {...rest} />
    </Stack>
  );
};

export default PostFoundryTable;
